var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsEnum, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { PainIntensityEnum } from '../enums/pain-intensity.enum.js';
import { PainLocationFullSizeDto } from './pain-location.full-size.dto.js';
export class CreateAnamnesisDto {
    userId;
    icd10Id;
    symptomDescription;
    painSensations;
    painScale;
    painDuration;
    secondarySymptoms;
    painTrigger;
    painOccurrences;
    painIntensity;
    painRadiation;
    additionalFactors;
    successTarget;
    painLocations = [];
}
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "icd10Id", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "symptomDescription", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "painSensations", void 0);
__decorate([
    IsNumber(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateAnamnesisDto.prototype, "painScale", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "painDuration", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "secondarySymptoms", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "painTrigger", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "painOccurrences", void 0);
__decorate([
    IsEnum(PainIntensityEnum),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "painIntensity", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "painRadiation", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "additionalFactors", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], CreateAnamnesisDto.prototype, "successTarget", void 0);
__decorate([
    IsArray(),
    Type(() => PainLocationFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], CreateAnamnesisDto.prototype, "painLocations", void 0);
//# sourceMappingURL=create-anamnesis.dto.js.map